import type { IPassengerInfo, IStationInfo } from "../dto";
import type {
  DirectionEnum,
  DirectionsServiceEnum,
  RebuildRouteTypeEnum,
  RouteRebuildSourceEnum,
  StationOptionsEnum,
} from "../enums";
import type { IRemovedAreaWaypoint } from "./area.models";

export interface IPassengerForStationDto {
  id: number;
  passengerCode?: string;
  lastName?: string;
  firstName?: string;
  sourceStation1Id?: number;
  sourceStation2Id?: number;
  sourceStation3Id?: number;
  destinationStation1Id?: number;
  destinationStation2Id?: number;
  destinationStation3Id?: number;
  sourceStation1Title?: string;
  sourceStation2Title?: string;
  sourceStation3Title?: string;
  destinationStation1Title?: string;
  destinationStation2Title?: string;
  destinationStation3Title?: string;
  siteId?: number | null;
  isLimitedPermissionsSite?: boolean;
}

export interface IPassengerForStationCriteriaDto {
  excludeIds?: number[];
}

export class RecountRideStationsCriteriaDto {
  id: number;
  stations: IStationInfo[];
  passengersInfo: IPassengerInfo[];
  passengerIds: number[];
  rideStart: TDateISO;
  rideEnd: TDateISO;
  direction: DirectionEnum;
  optimize = true;
  avoidTolls?: boolean;
  provider?: DirectionsServiceEnum;
  supplierId: number | null;
  vehicleTypeId?: number;
  token?: string;
  rebuildType?: RebuildRouteTypeEnum;
  sourceUsedCachedRouteId?: number | null;
  sourceCustomStationRouteId?: number | null;
  /** When true, BE returns recounted stations as-is so FE can accept/merge the new ML path. */
  shouldAcceptNewCustomizedMlPath?: boolean;
  /** When true, BE does not use a saved ML path for this rebuild. */
  skipMlPath?: boolean;
  removedAreaWaypoints?: IRemovedAreaWaypoint[];
  constructor(constructorData?: Partial<RecountRideStationsCriteriaDto>) {
    Object.assign(this, constructorData);
  }
}

export interface IRecountStationsResultDto {
  stationIds: number[];
  stationsInfo: IStationInfo[];
  totalDuration?: number;
  totalDistance?: number;
  distances?: number[];
  durations?: number[];
  routePolyline?: string;
  customStationRouteId?: number;
  usedCachedRouteId?: number;
  directionsService?: DirectionsServiceEnum;
  routeRebuildSource?: RouteRebuildSourceEnum;
  /** The sent list without the deletes whose area left the ride. */
  removedAreaWaypoints?: IRemovedAreaWaypoint[];
}

/** Ride-screen A/B options: pickUp ← stationOptionA, dropOff ← stationOptionB. */
export type TRideStationOptions = {
  pickUp: StationOptionsEnum;
  dropOff: StationOptionsEnum;
};
